module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Orange.2371e061.jpg";